import React from 'react'
import {connect} from 'react-redux'
import {number, shape, string} from 'prop-types'
import {language} from '../../helpers/login.data'
import localeData from '../../helpers/login.lang'
import RequirementItem from './requiermentItem/requiermentItem.presenter'

const locale = localeData[language]

const PasswordRequirements = ({passwordPolicy, password}) => (
  <div className='passwordRequirements'>
    <div className='title'>{locale.passwordRequirementsTitle()}</div>
    {
      Object.keys(passwordPolicy)
        .filter(key => key !== 'expireDays' && passwordPolicy[key])
        .map(policyName =>
          (
            <RequirementItem
              key={[policyName]}
              password={password}
              passwordPolicy={passwordPolicy}
              policyName={policyName}
            />
          ))
    }
  </div>
)

const mapStateToProps = ({loginReducer}) => ({
  passwordPolicy: loginReducer.passwordPolicy,
  password: loginReducer.password
})

PasswordRequirements.propTypes = {
  password: string,
  passwordPolicy: shape({
    minLength: number,
    minLowercase: number,
    minUpperCase: number,
    minNumbers: number,
    minSpecial: number
  })
}

export default connect(mapStateToProps)(PasswordRequirements)
